export default (function (_ref) {
  var request = _ref.request;
  return {
    dailyReportQuery: function dailyReportQuery(data) {
      return request({
        url: '/mng/dailyReport',
        method: 'get',
        params: data
      });
    },
    dailyReportDetail: function dailyReportDetail(id) {
      return request({
        url: "/mng/dailyReport/".concat(id),
        method: 'get'
      });
    },
    dailyReportCreate: function dailyReportCreate(data) {
      return request({
        url: '/mng/dailyReport',
        method: 'post',
        params: data
      });
    }
  };
});